module.exports = __webpack_public_path__ + "img/image3.c0188c55.jpg";